import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { routes } from "../../constants/routes";
import { injectModels } from "../../redux/injectModels";
import { EventService } from "../../services";
import { toast } from "react-toastify";
import { EventStatus } from "../../constants/Enum";
import { Modal, Button } from "react-bootstrap";
import { handleConsoleError } from "../../utils/common-methods";

const EventDashboard = ({ children }) => {
  const { eventId } = useParams();
  const [selectedEvent, setSelectedEvent] = useState(
    null // Initialize with empty object to avoid errors
  );
  // const [selectedStatus, setSelectedStatus] = useState("");
  //const [selectedStatus, setSelectedStatus] = useState(""); // Current status
  const [newStatus, setNewStatus] = useState(""); // Temporary status before confirmation
  const [showModal, setShowModal] = useState(false); // Modal visibility

  const handleStatusChange = (selectedValue) => async (event) => {
    event.preventDefault();
    setNewStatus(selectedValue); // Store selected status
    setShowModal(true); // Show confirmation modal
  };

  const confirmStatusChange = async () => {
    // setSelectedStatus(newStatus); // Apply new status
    setShowModal(false); // Hide modal

    const request = {
      eventId: selectedEvent?.id,
      eventStatus: newStatus,
    };

    try {
      const response = await EventService.UpdateEventStatus(request);
      if (response?.isSuccess) {
        toast.success(response?.message);
        setTimeout(() => {
          window.location.reload();
        }, 3000); // delay in milliseconds (3000ms = 3 seconds)

        //window.location.reload();
      } else {
        toast.error("Failed to update status.");
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  useEffect(() => {
    const bootstrapAsync = async () => {
      const storedEvent = await EventService.getEventById(eventId);
      if (storedEvent && storedEvent.data) {
        setSelectedEvent({
          name: storedEvent?.data?.eventName,
          id: storedEvent?.data?.id,
          status: storedEvent?.data?.eventStatusId,
        });
      }
    };
    bootstrapAsync();
  }, []);

  return (
    <React.Fragment>
      <section className="edit-form-table mt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-2">
              <aside>
                <ul className="list-unstyled ps-0 sidemenu">
                  <li className="mb-1">
                    <button
                      className="btn btn-toggle btn-toggle-nw align-items-center  collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#home-collapse"
                      aria-expanded="false"
                    >
                      Home {selectedEvent && "(" + selectedEvent?.name + ")"}
                    </button>
                    <div className="collapse show submenu" id="home-collapse">
                      <ul className="btn-toggle-nav list-unstyled fw-normal small ">
                        <li>
                          <Link
                            to={
                              selectedEvent &&
                              selectedEvent?.status === EventStatus.Published
                                ? routes.EVENT_DETAILS.replace(
                                    ":eventId",
                                    selectedEvent?.id
                                  )
                                : routes.ACCOUNT_EDIT_EVENT.replace(
                                    ":eventId",
                                    selectedEvent?.id
                                  )
                            }
                            className="link-dark"
                          >
                            Event Information
                          </Link>
                        </li>

                        <li>
                          <Link
                            to={routes.EVENT_GLOBAL_SETTINGS_LIST.replace(
                              ":eventId",
                              selectedEvent?.id
                            )}
                            className="link-dark "
                          >
                            Optional Extras
                          </Link>
                        </li>

                        <li>
                          <Link
                            to={routes.EVENT_MAP.replace(
                              ":eventId",
                              selectedEvent?.id
                            )}
                            className="link-dark "
                          >
                            Site Plan
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={routes.Event_CONTRACT.replace(
                              ":eventId",
                              selectedEvent?.id
                            )}
                            className="link-dark "
                          >
                            {/* Contracts */}
                            Trader Contract & Communications Templates
                          </Link>
                        </li>

                        <li>
                          <Link
                            to={routes.EVENT_DOCUMENT.replace(
                              ":eventId",
                              selectedEvent?.id
                            )}
                            className="link-dark "
                          >
                            Upload Trader Contract & Communication Documentation
                          </Link>
                        </li>
                        {/* <li>
                          <a href="#!" className="link-dark ">
                            Documents
                          </a>
                        </li> */}
                      </ul>
                    </div>
                  </li>
                  <li className="mb-1">
                    <button
                      className="btn btn-toggle btn-toggle-nw align-items-center  collapsed"
                      data-bs-toggle="collapse"
                      data-bs-target="#dashboard-collapse"
                      aria-expanded="false"
                    >
                      Caterer
                    </button>
                    <div className="collapse submenu" id="dashboard-collapse">
                      <ul className="btn-toggle-nav list-unstyled fw-normal small ">
                        <li>
                          <Link
                            to={routes.EVENT_CREATE_APPLICATION.replace(
                              ":eventId",
                              selectedEvent?.id
                            ).replace(":param", "C")}
                            className="link-dark "
                          >
                            Create Application
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={routes.CATERS_ACCOUNT_PITCHES.replace(
                              ":eventId",
                              selectedEvent?.id
                            )}
                            className="link-dark "
                          >
                            Create Individual Pitches
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={routes.SUBMISSION_CATERER.replace(
                              ":eventId",
                              selectedEvent?.id
                            )}
                            className="link-dark "
                          >
                            Applications Received
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="mb-1">
                    <button
                      className="btn btn-toggle btn-toggle-nw align-items-center "
                      data-bs-toggle="collapse"
                      data-bs-target="#orders-collapse"
                      aria-expanded="true"
                    >
                      Retail Trade Stands
                    </button>
                    <div className="collapse submenu" id="orders-collapse">
                      <ul className="btn-toggle-nav list-unstyled fw-normal small ">
                        <li>
                          <Link
                            to={routes.EVENT_CREATE_APPLICATION.replace(
                              ":eventId",
                              selectedEvent?.id
                            ).replace(":param", "R")}
                            className="link-dark "
                          >
                            Create Application
                          </Link>
                        </li>
                        {/* <li>
                          <a href="#!" className="link-dark ">
                            Applications
                          </a>
                        </li> */}
                        <li>
                          <Link
                            to={routes.ACCOUNT_PITCHES.replace(
                              ":eventId",
                              selectedEvent?.id
                            )}
                            className="link-dark "
                          >
                            Create Individual Pitches
                          </Link>
                        </li>
                        {/* <li>
                          <a href="#!" className="link-dark ">
                            Pitch setup
                          </a>
                        </li> */}

                        <li>
                          <Link
                            to={routes.SUBMISSION_RETAILER.replace(
                              ":eventId",
                              selectedEvent?.id
                            )}
                            className="link-dark "
                          >
                            Applications Received
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li className="mb-1">
                    <button
                      className="btn btn-toggle-nw align-items-center "
                      data-bs-toggle="collapse"
                      data-bs-target="#tickets-collapse"
                      aria-expanded="true"
                    >
                      Ticketing
                    </button>
                    <div className="collapse submenu" id="tickets-collapse">
                      <ul className="btn-toggle-nav list-unstyled fw-normal small ">
                        <li>
                          <Link
                            to={routes.EVENT_CREATE_TICKET.replace(
                              ":eventId",
                              selectedEvent?.id
                            )}
                            className="link-dark "
                          >
                            Create
                          </Link>
                        </li>
                        <li>
                          <Link
                            to={routes.EVENT_TICKETS.replace(
                              ":eventId",
                              selectedEvent?.id
                            )}
                            className="link-dark "
                          >
                            Insights
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>

                  <li className="mb-1">
                    <button
                      className="btn btn-toggle-nw align-items-center "
                      data-bs-toggle="collapse"
                      data-bs-target="#salesData-collapse"
                      aria-expanded="true"
                    >
                      Audience Numbers and Past Sales Data
                    </button>
                    <div className="collapse submenu" id="salesData-collapse">
                      <ul className="btn-toggle-nav list-unstyled fw-normal small ">
                        {/* <li>
                          <Link
                            to={routes.ENENT_AUDENCE}
                            className="link-dark "
                          >
                            Audiences
                          </Link>
                        </li> */}
                        <li>
                          <Link
                            to={routes.EVENT_POST_DATA.replace(
                              ":eventId",
                              selectedEvent?.id
                            )}
                            className="link-dark "
                          >
                            Audiences & Past Sales
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>

                  {(selectedEvent?.status === EventStatus.Published ||
                    selectedEvent?.status === EventStatus.InProgress ||
                    selectedEvent?.status === EventStatus.Completed ||
                    selectedEvent?.status === EventStatus.Canceled) && (
                    <li className="mb-1 bg-pink">
                      <button
                        className="btn btn-toggle btn-toggle-nw align-items-center bg-pink"
                        data-bs-toggle="collapse"
                        data-bs-target="#status-collapse"
                        aria-expanded="true"
                      >
                        Change My Event Status
                      </button>
                      <div className="collapse submenu" id="status-collapse">
                        <ul className="btn-toggle-nav list-unstyled fw-normal small ">
                          <li>
                            <Link
                              className="link-dark "
                              onClick={handleStatusChange(
                                EventStatus.InProgress
                              )}
                            >
                              In Progress
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="link-dark "
                              onClick={handleStatusChange(
                                EventStatus.Completed
                              )}
                            >
                              Completed
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="link-dark "
                              onClick={handleStatusChange(
                                0 // Assuming 0 is for Stop Sale
                              )}
                            >
                              Stop Sales
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  )}

                  {/* Confirmation Modal */}
                  <Modal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    centered
                  >
                    <Modal.Header closeButton>
                      <Modal.Title>Confirm Status Change</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      Are you sure you want to change the event status?
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => setShowModal(false)}
                      >
                        Cancel
                      </Button>
                      <Button variant="primary" onClick={confirmStatusChange}>
                        Confirm
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </ul>
              </aside>
            </div>
            <div className="col-md-10">{children}</div>
          </div>

          <div></div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default injectModels(["application"])(EventDashboard);
